import LightBoxImage from './LightBoxImage';
import './LightBoxImage.scss';

export default LightBoxImage;
